(() => {
  const ROOT_ID = "gbof-upcart-taste-guarantee";
  const TARGET_ID = "upCart";
  const guaranteeUrl = "/pages/taste-guarantee";
  const markup =     '<aside id="' + ROOT_ID + '" class="gbof-upcart-taste-guarantee" aria-label="14-Day Taste Guarantee">' +
      '<span class="gbof-upcart-taste-guarantee__icon" aria-hidden="true">✓</span>' +
      '<span><strong>14-Day Taste Guarantee</strong><br><a href="' + guaranteeUrl + '">Credit or refund on affected products. No chilled-food return needed.</a></span>' +
    '</aside>';
  const observedRoots = new WeakSet();
  const observer = new MutationObserver(() => mount());
  const mount = () => {
    const host = document.getElementById(TARGET_ID);
    if (!host) return false;
    const root = window.upcartDocumentOrShadowRoot || host.shadowRoot || document;
    const existing = root.querySelector?.('#' + ROOT_ID);
    const legacy = document.getElementById(ROOT_ID);
    if (legacy && legacy.getRootNode() !== root) legacy.remove();
    if (existing) return true;
    if ((root instanceof ShadowRoot || root instanceof Document) && !observedRoots.has(root)) {
      observer.observe(root, { childList: true, subtree: true });
      observedRoots.add(root);
    }
    const guarantee = document.createElement("div");
    guarantee.innerHTML = markup;
    const element = guarantee.firstElementChild;
    if (!element) return false;
    const style = document.createElement("style");
    style.id = ROOT_ID + "-styles";
    style.textContent =       '.gbof-upcart-taste-guarantee{display:flex;gap:10px;align-items:flex-start;margin:12px 16px 4px;padding:11px 12px;background:#f7e6d7;border:1px solid #e16b30;border-radius:8px;color:#3a2427;font-family:inherit;font-size:13px;line-height:1.35}' +
      '.gbof-upcart-taste-guarantee__icon{display:inline-flex;flex:0 0 20px;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#e16b30;color:#fff;font-weight:900}' +
      '.gbof-upcart-taste-guarantee strong{font-size:14px;color:#3a2427}' +
      '.gbof-upcart-taste-guarantee a{color:#3a2427;text-decoration:underline;text-underline-offset:2px;font-weight:650}' +
      '.gbof-upcart-taste-guarantee a:focus-visible{outline:2px solid #3a2427;outline-offset:3px}' +
      '@media(max-width:420px){.gbof-upcart-taste-guarantee{margin:10px 12px 3px;padding:10px;font-size:12px}.gbof-upcart-taste-guarantee strong{font-size:13px}}';
    const insertionRoot = root instanceof ShadowRoot || root instanceof Document ? root : document;
    if (!insertionRoot.getElementById?.(style.id)) insertionRoot.appendChild(style);
    const cartRoot = root instanceof ShadowRoot ? root : host;
    const preferred = [...cartRoot.querySelectorAll("button,a")].find((node) => /checkout/i.test((node.textContent || "").trim()));
    if (!preferred?.parentElement) return false;
    preferred.parentElement.insertBefore(element, preferred);
    return true;
  };
  const begin = () => {
    mount();
    observer.observe(document.documentElement, { childList: true, subtree: true });
    const retry = window.setInterval(() => { if (mount()) window.clearInterval(retry); }, 150);
    window.setTimeout(() => window.clearInterval(retry), 15000);
    window.setInterval(mount, 1000);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", begin, { once: true }); else begin();
})();
